import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import DefaultLayout from 'components/DefaultLayout';
import { Filter, LogDetailsModal } from 'components/Modals';
import { QTable } from 'ui';
import moment from 'moment/moment';
import { EyeOutlined } from '@ant-design/icons';
import { filterModules } from './filter';
import { config } from 'config/config';

interface HistoryInterface {
    program: any;
    launchButton: HTMLElement;
}

const History: React.FC<HistoryInterface> = ({ program, launchButton }) => {
    const [reload, setReload] = useState(false);
    const [filter, setFilter] = useState('');

    const [showLogDetails, setShowLogDetails] = useState(false);
    const [logDetailsContent, setLogDetailsContent] = useState<any>({});

    const params = useParams();
    const intl = useIntl();
    const programId = params.id;

    const parseEventDiff = (oldValues: any, newValues: any) => {
        return {
            old: JSON.parse(oldValues),
            ...JSON.parse(newValues),
        };
    };

    const columns = [
        {
            title: intl.formatMessage({ id: 'general.event_type' }),
            dataIndex: 'eventType',
            key: 'eventType',
        },
        {
            title: intl.formatMessage({ id: 'general.event_subject_type' }),
            dataIndex: 'eventSubjectType',
            key: 'eventSubjectType',
        },
        {
            title: intl.formatMessage({ id: 'general.event_object_type' }),
            dataIndex: 'eventObjectType',
            key: 'eventObjectType',
        },
        {
            title: intl.formatMessage({ id: 'general.event_initiator_type' }),
            dataIndex: 'eventInitiatorType',
            key: 'eventInitiatorType',
        },
        {
            title: intl.formatMessage({ id: 'general.event_initiator' }),
            dataIndex: 'initiatorFullName',
            key: 'initiatorFullName',
        },
        {
            title: intl.formatMessage({ id: 'general.student_email' }),
            dataIndex: 'studentEmail',
            key: 'studentEmail',
        },
        {
            title: intl.formatMessage({ id: 'general.created_at' }),
            key: 'createdAt',
            render: (_: string, record: any) =>
                moment(record.createdAt).format(config.defaultFullDateFormat),
        },
        {
            title: intl.formatMessage({ id: 'system.audit.attributes' }),
            key: 'attributes',
            render: (_: string, record: any) => {
                return (
                    <p
                        className="description-icon"
                        onClick={() => {
                            setShowLogDetails(true);
                            setLogDetailsContent(
                                parseEventDiff(record.eventDataOld, record.eventDataNew)
                            );
                        }}
                    >
                        <FormattedMessage id={'general.show'} /> <EyeOutlined />
                    </p>
                );
            },
        },
    ];

    return (
        <>
            <Filter
                setFilter={setFilter}
                modules={filterModules}
                submit={() => setReload(true)}
            />

            <QTable
                tableKey={'programHistory'}
                columns={columns}
                url={`/api/v1/courses/learning-program/${programId}/history`}
                setReload={setReload}
                rowSelection={false}
                reload={reload}
                rowKey={'id'}
                filter={filter}
            />

            <LogDetailsModal
                visible={showLogDetails}
                onCancel={setShowLogDetails}
                content={logDetailsContent}
            />

            <DefaultLayout.PageFooter right={<>{launchButton}</>} />
        </>
    );
};

export default History;
